import type { FunctionComponent } from 'react';

import { useFeatureGate } from '@trello/feature-gate-client';

import { ResizableCollapsibleSplitScreenManager } from './ResizableCollapsibleSplitScreenManager';
import { ResizableSplitScreenManager } from './ResizableSplitScreenManager';

export const SplitScreenEntryComponent: FunctionComponent = () => {
  const { value: isBoardCollapseEnabled } = useFeatureGate(
    'phx_drag_to_collapse_board',
  );

  const SplitScreenManagerComponent = isBoardCollapseEnabled ? (
    <ResizableCollapsibleSplitScreenManager />
  ) : (
    <ResizableSplitScreenManager />
  );
  return SplitScreenManagerComponent;
};
